import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FileApiService } from 'src/app/services/api/file-api.service';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import SwiperCore, { Pagination, Autoplay } from 'swiper';

// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.scss'],
})
export class HomeCarouselComponent {
  constructor(
    private api: MarketingApiService,
    private fileApi: FileApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.findHomeCarousels();
  }

  carousels: any[] = [];
  async findHomeCarousels() {
    try {
      const r = await this.api.findHomeCarousels();
      this.carousels = r.data || [];
      for (const c of this.carousels) {
        c.cover = this.fileApi.fileurl(c.cover);
      }
    } catch (error) {}
  }

  click(c: any) {
    if (c.type === 'URL') {
      window.location.href = c.url;
    } else if (c.type === 'Article') {
      this.router.navigate(['/marketing/article', c.article_id]);
    }
  }
}
